module.exports = __webpack_public_path__ + "static/media/ImgKOR2.a8588e3f.svg";